















































































































































































import Vue, { PropType } from "vue";
import SelectBox from "@/components/util/SelectBox.vue";
import SearchBox from "@/components/util/SearchBox.vue";
import AddSkillModal from "@/parts/util/AddSkillModal.vue";
import ReviewCard from "@/parts/util/ReviewCard.vue";
import AdBanner from "@/parts/util/AdBanner.vue";
import ReturnTop from "@/parts/util/ReturnTop.vue";

import InfiniteLoading from "vue-infinite-loading";
import { Review, GetReviewsRequestParameters, DealSortType, dealSortTypes } from "@/api/dto/Review";
import { Completed, DealStatus, Pending } from '@/api/dto/DealStatus';
import { getReviews } from "@/api/Review";
import { UserProfile } from "@/api/dto/UserProfile";
import { login } from "../api/Login";

export default Vue.extend({
  name: "Search",
  components: {
    SelectBox,
    SearchBox,
    AddSkillModal,
    ReviewCard,
    AdBanner,
    ReturnTop,
    InfiniteLoading,
  },
  props: {
    mq: String,
    logged: Boolean, // ログイン状態
  },
  watch: {
    // 左メニューは変更時に検索
    sort() {
      this.initPage();
    },
    hideEnded() {
      this.initPage();
    },
    hideSkillLimit() {
      this.initPage();
    },

    /** 全体のチェックボックスが切り替わったときの処理 */
    openAll() {
      this.updateViewPermissions(this.openAll,this.viewPermissionEnum.openAll);
    },
    /** 初回無料依頼のチェックボックスが切り替わったときの処理 */
    firstTimeFree() {
      this.updateViewPermissions(this.firstTimeFree,this.viewPermissionEnum.firstTimeFree);
    },
    /** 法人依頼のチェックボックスが切り替わったときの処理 */
    corporate() {
      this.updateViewPermissions(this.corporate, this.viewPermissionEnum.corporate);
    },
  },
  data() {
    return {
      id: 0,
      /**
       * 検索結果
       */
      totalCount: 0,
      results: [] as Review[],
      /**
       * 検索クエリ
       */
      page: 0,
      sort: 2 as DealSortType,
      amount: 0,
      languages: [] as string[],
      keyword: "",
      viewPermissions:[] as string[],
      /**
       * 表示設定
       */
      hideSkillLimit: false,
      hideEnded: false,

      /**
       * レビュー種別
       */
      openAll:false,
      firstTimeFree:false,
      corporate:false,
      /**
       * 選択肢
       */
      amountOptions: [
        { value: 0, text: "指定なし" },
        { value: 3000, text: "¥3,000 以上" },
        { value: 4000, text: "¥4,000 以上" },
        { value: 5000, text: "¥5,000 以上" },
        { value: 10000, text: "¥10,000 以上" },
      ] as Array<{ value: number; text: string }>,
      sortOptions: [
        { value: 2, text: "期限が近い順" },
        { value: 3, text: "期限が遠い順" },
        { value: 4, text: "金額が低い順" },
        { value: 5, text: "金額が高い順" },
        { value: 1, text: "新着順" },
      ] as Array<{ value: DealSortType; text: string }>,
      displayOptions: [
        { value: 1, display: "スキル制限付を非表示", on: false },
        { value: 2, display: "終了済を非表示", on: true },
      ],
      langModal: false,
      searchSlide: true,

      /**閲覧権限の列挙型 */
      viewPermissionEnum: Object.freeze({
        // 全体
        openAll: "1",
        // 初回無料
        firstTimeFree: "2",
        // 法人
        corporate: "3",
      }),

      /**ユーザカテゴリの列挙型 */
      userCategoryEnum: Object.freeze({
        // 個人
        Individual: "1",
        // 個人事業主
        SoleProprietor: "2",
        // 法人
        Corporation: '3',
        // IDH社員
        IDHEmployee: '4',
      }),
    };
  },
  mounted() {
    this.setViewPermission();
  },
  computed: {
    queryStatuses(): DealStatus[] {
      if (this.hideEnded) {
        return [Pending];
      } else {
        return [Pending, Completed];
      }
    },
    query(): GetReviewsRequestParameters {
      return {
        page: this.page,
        sort: this.sort,
        amount: this.amount,
        statuses: this.queryStatuses,
        languages: this.languages,
        keyword: this.keyword,
        exclude: this.hideSkillLimit,
        viewPermissions: this.viewPermissions,
      };
    },
    isIDHEmployee() : boolean {
     return this.$store.getters.userProfile.userCategory === this.userCategoryEnum.IDHEmployee;
    },
    isIndividual() : boolean {
     return this.$store.getters.userProfile.userCategory === this.userCategoryEnum.Individual;
    },
  },
  methods: {
    /*
      検索を実行する
    */
    initPage() {
      this.id++;
      this.page = 0;
      this.totalCount = 0;
      this.results = [];
    },
    async fetchNextResults() {
      const { totalCount, results } = await getReviews(this.query);
      this.page++;
      this.totalCount = totalCount;
      this.results = [...this.results, ...results];
    },
    setAmountFilter(value: number) {
      this.amount = value;
    },
    setSortOption(value: number) {
      if (dealSortTypes.includes(value)) {
        this.sort = value as DealSortType;
      }
    },
    searchSlideToggle() {
      this.searchSlide = !this.searchSlide;
    },
    addModalOn() {
      this.langModal = true;
    },
    addModalOff() {
      this.langModal = false;
    },
    setLanguages(value: string[]) {
      this.languages = value;
    },
    cancelItem(key: number) {
        this.languages = this.languages?.filter((_, i) => i !== key) ?? null
    },

    /**
     * ログインユーザの区分によって検索して表示される依頼を絞り込む 
     */
    setViewPermission() {
      // 未ログイン、個人
      if (!this.logged || this.isIndividual) {
        this.viewPermissions.push(this.viewPermissionEnum.openAll);
        this.openAll = true;
        return;
      }
      // IDH社員
      if (this.isIDHEmployee) {
        this.viewPermissions.push(
          this.viewPermissionEnum.openAll,
          this.viewPermissionEnum.firstTimeFree,
          this.viewPermissionEnum.corporate);
        this.openAll = true;
        this.firstTimeFree = true;
        this.corporate = true;
        return;
      }

    },

    /**
     * viewPermissionsのリストから特定の要素を削除する
     * @param reviewType 削除したいレビュー種別
     */
    dropViewPermissionElem(reviewType: string) {
      this.viewPermissions = this.viewPermissions.filter((permission: string) => {
        return permission != reviewType;
      });
    },

    /**
     * viewPermissionsを更新する
     * @param check チェックボックスの判定
     * @param reviewType 更新対象のレビュー種別
     */
    updateViewPermissions(check: boolean, reviewType: string) {
      // viewPermissionsに0が含まれていた場合、0を削除
      if (this.viewPermissions.includes("0")) {
        this.dropViewPermissionElem("0");
      }
      if (check) {
        if (this.viewPermissions.includes(reviewType)) {
          return;
        }
        this.viewPermissions.push(reviewType);
      } else {
        this.dropViewPermissionElem(reviewType);
      }
      // 要素数が0のときは0を追加する
      if (!this.viewPermissions.length) {
        this.viewPermissions.push("0");
      }
      this.initPage();
    },


    async infiniteHandler($state: any) {
      // TODO: 全体のサイズをAPIが返す
      const preSize = this.results.length;
      try {
        await this.fetchNextResults();
        const postSize = this.results.length;
        if (preSize === postSize) {
          $state.complete();
        } else {
          $state.loaded();
        }
      } catch (e) {
        $state.error();
      }
    },
  },
});
